/**
 * CalculatorIcon (web) - SVG do simulador (loan_simulator).
 *
 * Espelha o /apps/mobile/src/components/CalculatorIcon.tsx: mesmo path/cores
 * mantendo consistencia visual admin <-> mobile.
 */

interface CalculatorIconProps {
  size?: number;
}

export function CalculatorIcon({ size = 24 }: CalculatorIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
    >
      <rect x={10} y={4} width={44} height={56} rx={6} fill="#2D3748" />
      <rect x={16} y={10} width={32} height={10} rx={2} fill="#A0AEC0" />
      <g fill="#E2E8F0">
        <rect x={16} y={26} width={6} height={6} rx={1} />
        <rect x={25} y={26} width={6} height={6} rx={1} />
        <rect x={34} y={26} width={6} height={6} rx={1} />
        <rect x={43} y={26} width={6} height={6} rx={1} />
        <rect x={16} y={35} width={6} height={6} rx={1} />
        <rect x={25} y={35} width={6} height={6} rx={1} />
        <rect x={34} y={35} width={6} height={6} rx={1} />
        <rect x={43} y={35} width={6} height={6} rx={1} />
        <rect x={16} y={44} width={6} height={6} rx={1} />
        <rect x={25} y={44} width={6} height={6} rx={1} />
        <rect x={34} y={44} width={6} height={6} rx={1} />
        <rect x={43} y={44} width={6} height={6} rx={1} />
      </g>
      <rect x={43} y={53} width={6} height={4} rx={1} fill="#48BB78" />
    </svg>
  );
}
